export enum NotifierMessageType {
  PHOTO_SERVICE_SET_MAIN_PHOTO = 'photo_service_event:main_photo_set',
  PHOTO_SERVICE_PHOTO_DELETED = 'photo_service_event:photo_deleted',
  PHOTO_SERVICE_PHOTO_EDITED = 'photo_service_event:photo_edited',
  PHOTO_PHOTO_CHANGED_PHOTO_MAIN_PHOTO_SET = 'photo:photo_changed:main_photo_set',
  PHOTO_PHOTO_CHANGED_PHOTO_DELETED = 'photo:photo_changed:photo_deleted',
  PHOTO_PHOTO_CHANGED_PHOTO_EDITED = 'photo:photo_changed:photo_edited'
}
